// extracted by mini-css-extract-plugin
export default {"container":"AITutorV2__container___RJIqz","overflowYAuto":"AITutorV2__overflowYAuto___wE8KD","skeleton-loading":"AITutorV2__skeleton-loading___tT6c0"};